export const preloadImage = (url: string, document: Document, extraAttributes?: Record<string, string>) => {
  if (document.head.querySelector(`link[rel="preload"][href="${url}"]`)) return;
  const link = document.createElement('link');
  link.rel = 'preload';
  link.href = url;
  // Angular SSR doesn't serialize .as and .fetchPriority properties to HTML attributes
  link.setAttribute('as', 'image');
  if (extraAttributes) {
    Object.entries(extraAttributes).forEach(([key, value]) => {
      link.setAttribute(key, value);
    });
  }
  document.head.appendChild(link);
};
